import TabbedWidget from "./widgets/TabbedWidget";
import Choropleth from "./widgets/Choropleth";
import Timeline from "./widgets/Timeline";
import Top from "./widgets/Top";
import Overview from "./widgets/Overview";

export default function loader() {
  /**
   * Check DOM for Tabbed Widget
   */
  const widgetsTabbed = [].slice.call(
    document.querySelectorAll("[data-sh-tabbed]")
  );
  widgetsTabbed.map(function (el) {
    const feed = el.getAttribute("data-sh-tabbed");
    const dimension = el.getAttribute("data-sh-dimension");
    const widget = new TabbedWidget(feed, dimension);
    widget.theme = el.getAttribute("data-theme");
    widget.init(el);
  });

  /**
   * Check DOM for Choropleth geomap visualisations
   */
  const choropleths = [].slice.call(document.querySelectorAll("[data-sh-geo]"));
  choropleths.map(function (el) {
    const feed = el.getAttribute("data-sh-geo");
    const widget = new Choropleth(feed);
    widget.theme = el.getAttribute("data-theme");
    widget.init(el);
  });

  /**
   * Check DOM for Timeline visualisations
   */
  const datafeedTimelines = [].slice.call(
    document.querySelectorAll("[data-sh-timeline]")
  );
  datafeedTimelines.map(function (el) {
    const feed = el.getAttribute("data-sh-timeline");
    const widget = new Timeline(feed);

    widget.theme = el.getAttribute("data-theme");
    widget.init(el);
  });

  /**
   * Check DOM for Top visualisations
   */
  const tops = [].slice.call(document.querySelectorAll("[data-sh-top]"));
  tops.map(function (el) {
    const feed = el.getAttribute("data-sh-top");
    const dimension = el.getAttribute("data-sh-dimension");
    const widget = new Top(feed, dimension);

    widget.theme = el.getAttribute("data-theme");
    widget.init(el);
  });

  const overviews = [].slice.call(
    document.querySelectorAll("[data-sh-listings-overview]")
  );
  overviews.map(function (el) {
    const feed = el.getAttribute("data-sh-listings-overview");
    const widget = new Overview(feed);

    widget.theme = el.getAttribute("data-theme");
    widget.init(el);
  });
}
